(function () {
  if (window.musayoGiftBalanceBound) return;
  window.musayoGiftBalanceBound = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var query =
    'mutation($codes: [String!]) { cartCreate(input: { giftCardCodes: $codes }) {' +
    ' cart { appliedGiftCards { lastCharacters balance { amount currencyCode } } } } }';

  function show(form, text) {
    var status = form.querySelector('[data-status]');
    status.hidden = false;
    status.textContent = text;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-musayo-gift-balance]');
    if (!form) return;
    event.preventDefault();

    var input = form.querySelector('input[name="code"]');
    var button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    var code = (input.value || '').replace(/\s+/g, '');
    if (!code) return;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    input.removeAttribute('aria-invalid');
    show(form, form.getAttribute('data-loading'));

    fetch(root + 'api/2025-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query, variables: { codes: [code] } }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (json) {
        var cart = json && json.data && json.data.cartCreate && json.data.cartCreate.cart;
        if (!cart) throw new Error('no cart');
        var card = cart.appliedGiftCards[0];
        if (!card) {
          input.setAttribute('aria-invalid', 'true');
          show(form, form.getAttribute('data-invalid'));
          input.focus();
          return;
        }
        var amount = new Intl.NumberFormat(document.documentElement.lang || 'it', {
          style: 'currency',
          currency: card.balance.currencyCode,
        }).format(Number(card.balance.amount));
        show(
          form,
          form.getAttribute('data-result').replace('[last]', card.lastCharacters).replace('[balance]', amount)
        );
      })
      .catch(function () {
        show(form, form.getAttribute('data-error'));
      })
      .then(function () {
        button.disabled = false;
        form.removeAttribute('aria-busy');
      });
  });
})();
